/**
 * Whether a query can be searched: at least two letters or digits, the way the API reads a query
 * (`searchTerms`: letters and digits only, SDD §18.4). Punctuation alone is not a search.
 */
export function isSearchable(query: string): boolean {
  return (query.match(/[\p{L}\p{N}]/gu) ?? []).length >= 2;
}
